import { IServices } from "./IServices";

export const ProfileApi: string = 'IProfileApi'
export const AdminApi: string = 'IAdminApi'
export const AgeGroupApi: string = 'IAgeGroupApi'
export const RoomApi: string = 'IRoomApi'
export const EventTypeApi: string = 'IEventTypeApi'
export const EventApi: string = 'IEventApi'
export const OrderApi: string = 'IOrderApi'
export const InvoiceApi: string = 'IInvoiceApi'
export const ContactInfoApi: string = 'IContactInfoApi'
export const EventSchedulesApi: string = 'IEventSchedulesApi'
export const HtmlTextsApi: string = 'IHtmlTextsApiApi'
export const PhotoGalleryApi: string = 'IPhotoGalleryApi'


class Services implements IServices {

    [key: string]: any;
    GetService<T>(id: string): T {
        if (this.hasOwnProperty(id)) {
            if (typeof this[id] === 'function') {
                return new this[id]();
            }
            else {
                return this[id] as T;
            }
        }
        else {
            throw new Error("Service does not exits.");
            //return "" as any as T;
        }
    }

    Register(id: string, service: any) {
        if (this.hasOwnProperty(id)) {
            throw new Error("Service is already registred.");
        }
        else {
            this[id] = service;
        }
    }

    Unregister(id: string) {
        delete this[id];
    }

}

export const ServicesProvider = new Services();

 
